import { useMutation } from 'react-query';

import { updatePasscode } from '../services';

export const useUpdatePasscode = ({
  onSuccess,
}: {
  onSuccess: (data: { message: string; succeeded: boolean }) => void;
}) => {
  return useMutation({
    mutationFn: updatePasscode,
    onSuccess,
  });
};
